<template>
	<md-select v-model="value"
			   @input="input"
			   @keydown.tab="tabbed"
			   @md-opened="opened"
			   :md-class="contentClass"
			   v-bind="$attrs"
			   v-on="$listeners"
			   :disabled="disabled"
			   :required="required"
			   ref="internal"
	>
		<md-field v-if="searchAllow" style="padding:0.8rem 1rem">
			<label style="padding:0 1rem">{{ $t("common.search") }}</label>
			<md-input @input="search" :value="searchValue" ref="searchInput"></md-input>
		</md-field>
		<slot v-if="!options"/>
		<md-option v-else v-for="item in searchResults" :value="getOptionValue(item)" :key="getOptionKey(item)">
			{{ getOptionDisplayValue(item) }}
		</md-option>
		<md-option v-if="searchResults && searchResults.length === 0" disabled>
			{{ emptyText }}
		</md-option>
		<slot name="after"/>
	</md-select>
</template>

<script>

import SelectBaseComponent from "@/components/templates/common/SelectBaseComponent";

export default {
	extends: SelectBaseComponent,
	props: {
		value: { },
		contentSize: { type: "small" | "medium" | "large" | "xl", default: "medium" },
	},
	computed: {
		contentClass() {
			return "md-select-menu-content-" + this.contentSize;
		},
	},
	methods: {
		input(value) {
			this.$emit("input", value);
		},
		tabbed() {
			// Fix: Prevents a bug where selected values change when navigating using the tab button in a form with multiple selects.
			this.$refs.internal.$refs.menu.destroyKeyDownListener();

			// Also add the desired behaviour that a select closes by using the tab button.
			if (this.$refs.internal.showSelect) {
				document.body.click();
			}
		},
		opened() {
			// Fix: Make sure the current element has focus, otherwise it can happen that keyboard navigation also
			// triggers for previously used select fields as those are somehow still focused.
			// This has to happen a little delayed because the previous select is focused on close, so we make sure
			// this happens afterwards.
			// Also see: https://github.com/vuematerial/vue-material/issues/2136
			setTimeout(function() {
				if (this.searchAllow) {
					this.$refs.searchInput.$el.focus();
				} else {
					this.$refs.internal.onFocus();
				}
			}.bind(this), 1);
		},
	}
};
</script>